// src/components/orders/OrderSearch.js

import React from 'react';
import { Input } from '../ui/input';

const OrderSearch = ({ searchTerm, setSearchTerm, onSearch }) => {
  return (
    <form onSubmit={onSearch} className="flex items-center space-x-2">
      <div className="relative">
        <Input
          type="text"
          placeholder="Search consignment no..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-64 pl-3 pr-10"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={() => setSearchTerm('')}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            ×
          </button>
        )}
      </div>
      {/* <Button type="submit" variant="outline" size="sm">
        Search
      </Button> */}
    </form>
  );
};

export default OrderSearch;